import React from 'react';

import PropTypes from 'prop-types';

import ELearningCourseEnrolledPill from 'components/courses/pills/ELearningCourseEnrolledPill';
import ELearningCourseInProgressPill from 'components/courses/pills/ELearningCourseInProgressPill';
import RegularCourseBookedPill from 'components/courses/pills/RegularCourseBookedPill';

export default function CourseBookedProgressPill({
  booking,
  isELearningProviderSelected,
  registration,
}) {
  return (
    <span className='tw-ml-2'>
      {isELearningProviderSelected ?
        registration ?
          <ELearningCourseInProgressPill />
        : <ELearningCourseEnrolledPill />
      : <RegularCourseBookedPill booking={booking} />}
    </span>
  );
}

CourseBookedProgressPill.propTypes = {
  booking: PropTypes.object.isRequired,
  isELearningProviderSelected: PropTypes.bool.isRequired,
  registration: PropTypes.object,
};
